import { createContext } from 'react';

import { PreviewInputsContextValue } from '../../types';

export const PreviewInputsContext =
  createContext<PreviewInputsContextValue | null>(null);
